import {ImageService} from '../../../services/image.service';
import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CartItem} from '../../../../shared/classes/cart-item';
import {CartService} from '../../../../shared/services/cart.service';
import {ArticleFilter} from '../../../models/article';
import {Router} from '@angular/router';
import {SearchService} from '../../../services/search.service';
import {Subscription} from 'rxjs';

declare var $: any;

@Component({
    selector: 'app-header-widgets',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    providers: [ImageService],
    standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy {
    @Input() articleFilter: ArticleFilter;
    @Output() findArticles: EventEmitter<any> = new EventEmitter();
    public show = false;
    private cartSubscription: Subscription;
    public cartItemCount: number = 0;

    constructor(private translate: TranslateService, public cartService: CartService,
                 private uploadFileService: ImageService,
                private _router: Router, private searchService: SearchService,
                private cdr: ChangeDetectorRef) {
        this.articleFilter = new ArticleFilter();
    }

    ngOnInit() {
        // Subscribe to update cart count
        this.cartSubscription = this.cartService.cartItems.subscribe(items => {
            this.cartItemCount = items.reduce((total, item) => total + item.quantity, 0);
            // Trigger change detection
            this.cdr.detectChanges();
        });
    }

    ngOnDestroy() {
        if (this.cartSubscription) {
            this.cartSubscription.unsubscribe();
        }
    }

    public openSearch() {
        this.show = true;
    }

    public closeSearch() {
        this.show = false;
    }

    public removeItem(item: CartItem) {
        this.cartService.removeFromCart(item);
    }

    find = () => {
        this.searchService.buscarProducto(this.articleFilter.articleFind.trim());
        if (this.articleFilter.articleFind.trim() !== '') {
            this._router.navigate(['/home/articles', this.articleFilter.articleFind.trim()]);
        } else {
            this._router.navigate(['/home/articles']);
        }
        this.closeSearch();
    }

    clean = () => {
        this.searchService.vaciarProductoABuscar();
        this._router.navigate(['/']);
        this.closeSearch();
    }

}
